var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.mobile)?_c('HeaderMobile'):_c('Header'),_c('router-view'),_c('Form'),_c('Footer'),_c('div',{staticClass:"bottom-border"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }